<mat-card class="content-card">

  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <mat-card-title>
    </mat-card-title>
    <div fxFlex ></div>
    <a mat-raised-button color="primary" routerLink="new-push">New Push</a>
    <a mat-raised-button color="primary" routerLink="new-sms">New SMS</a>
    <a mat-raised-button color="primary" routerLink="new">New E-Mail</a>
  </mat-card-header>

  <div fxLayout="column">
    <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">


      <!--<div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <mat-form-field style="width: 400px;" class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                 [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="table.clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>-->
    </div>

  </div>

  <app-mat-table-generator #table
      tableName = "emailtable"
      [useEmbededFilter]="false"
      [columns] ="columns"
      [dataSource] ="dataSource"
      [viewLink]="getViewLink"
      [deleteEnabled]="deleteEnabled()"
      [multiselectEnabled]="deleteEnabled()"
      [customActions]="sendMailCustomActions"
  >
  </app-mat-table-generator>
</mat-card>
